import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useCountryContext, useEvolvedContext } from '../../context'
import NationalFooter from '../../components/national-footer'
import { UniversalFooter } from '../../components/universal-footer'
import ErrorFeature from '../../components/error-feature'
import { useUniversalHeader } from '../../hub-components/universal-header'

const Error = ({ error, status, headerStaticData }) => {
  const country = useCountryContext()
  const isEvolved = useEvolvedContext()

  const [Header, setHeaderNavigationPath] = useUniversalHeader({
    variant: 'national',
    data: headerStaticData,
  })

  return (
    <Fragment>
      <Header />
      <main>
        <ErrorFeature error={error} status={status} />
      </main>
      {isEvolved ? (
        <UniversalFooter
          Link={Link}
          country={country}
          onFindACentre={() => setHeaderNavigationPath(['find-a-centre'])}
        />
      ) : (
        <NationalFooter />
      )}
    </Fragment>
  )
}

Error.defaultProps = {
  status: 404,
}

Error.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  status: PropTypes.number,
  headerStaticData: PropTypes.object.isRequired,
}

export default Error
